/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { call, put, select, takeLatest } from "redux-saga/effects";

import { getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";

import { siteLocationPrefix } from "../../constants";
import { OnboardingErrorType } from "../../models/errors";
import { Programs } from "../../models/programsConfig";
import {
  AAAGameConceptsQuery,
  AaaGameConceptsQueryResponse,
} from "../../server/crm/api/models/forms";
import { AaaGameConceptsActions, aaaGameConceptsActions } from "../actions/aaaActions";
import { statusActions } from "../actions/statusActions";
import { getAAAGameConceptsQuery } from "../selectors";
import { storeError } from "./dataStorage/storeError";

export function* aaaGameConceptsListStart(
  action: ReturnType<typeof aaaGameConceptsActions.aaaGetConcepts.start>
) {
  const isSigned: boolean | undefined = yield select(getIsUserSignedIn);
  if (!isSigned) {
    return;
  }
  try {
    yield put(statusActions.updateIsLoadingGameConcept(true));
    const gameConceptQuery: AAAGameConceptsQuery | undefined =
      yield select(getAAAGameConceptsQuery);

    const getPaginatedGameConceptsUrl = `${siteLocationPrefix}/forms/paginatedGameConcepts`;
    const requestBody = {
      ...action.query,
      queryData: gameConceptQuery,
    };
    const response: Response = yield call(fetch, getPaginatedGameConceptsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ paginatedData: requestBody }),
    });
    const data: AaaGameConceptsQueryResponse = yield response.json();
    if (data) {
      yield put(
        aaaGameConceptsActions.updateConceptsList(
          data.gameConceptsList,
          Programs.Aaa,
          data.gameConceptsListQuery
        )
      );
    }
  } catch (e) {
    yield storeError(e, OnboardingErrorType.Save);
  } finally {
    yield put(statusActions.updateIsLoadingGameConcept(false));
  }
}

export function* aaaProgramSagas() {
  yield takeLatest(
    AaaGameConceptsActions.AAA_UPDATE_GAME_CONCEPT_LIST_START,
    aaaGameConceptsListStart
  );
}
